import { get, writable } from 'svelte/store';
import { getUserFriends } from '../controllers/APIController';

const friendsStore = () => {
  	
	const state = null;
	const { subscribe, set, update } = writable(state);
	
    const methods = {
        async getFriends (userId) {
            const res = await getUserFriends(userId);

            //TODO: temporary fake data
            /*res.friends = [
                {user_id: "QBXc6c141bf7b2fc28a", name: "Val2", avatar: "/assets/avatar.png"},
                {user_id: "QBXq32424", name: "John", avatar: "/assets/avatar.png"},
                {user_id: "QBXq24234", name: "Michael", avatar: "/assets/avatar.png"},
                {user_id: "QBXq37547", name: "Steve", avatar: "/assets/avatar.png"}
            ]*/

            console.log("friends: " + JSON.stringify(res.friends));
            console.log("blocked: " + JSON.stringify(res.blocked_invites));

            res.friendIds = [];
            res.blockedIds = [];
            for(let friend of res.friends)
            {
                if (!friend.pic)
                    friend.pic = "/assets/avatar.png";
                res.friendIds.push(friend.uid);
            }
            for(let blocked of res.blocked_invites)
            {
                if (!blocked.pic)
                    blocked.pic = "/assets/avatar.png";
                res.blockedIds.push(blocked.uid);
            }

            set(res);        //save friends
        }
    }

    return {
        subscribe,
        update,
        ...methods
    }
}

export default friendsStore();